































































import Vue from "vue";
import axios, { AxiosPromise } from "axios";
import moment from "moment";
import get from "lodash-es/get";
import isEmpty from "lodash-es/isEmpty";
import debounce from "lodash-es/debounce";
import PivotGrid from "../../components/PivotGrid.vue";
import PivotChart from "../../components/PivotChart.vue";
import TransitionExpand from "../../components/TransitionExpand.vue";
import TemplateSelection from "../../components/PivotTemplateSelection.vue";
import OrdersPivotFilters from "./OrdersPivotFilters.vue";
import { FilterPivotOrderValues } from "./OrdersPivotFilters.vue";
import { PivotDefinitieType } from "../../PublicEnums";
import { FixedPeriodType, LookupItemViewModel } from "../../TypeScriptModels";
import { EventBus } from "../../lib/EventBus";

enum RelatieSoort {
  Onbekend = 0,
  Particulier = 1,
  Zakelijk = 2,
  Lease = 3,
}

interface PivotOrderQueryViewModel {
  FromDate: string;
  ToDate: string;
  ComparePeriodData: boolean;
  FromDateCompare: string;
  ToDateCompare: string;
  Autobedrijven: any[];
  Vestigingen: any[];
  Modellen: any[];
  Zones: any[];
  Modeljaren: any[];
}

interface PivotOrderWithLabelsViewModel {
  Model: string;
  Order: string;
  WeeknumberOrder: number;
  WeeknumberGoedgekeurd: number;
  ZoneID: number;
  Zone: string;
  AutobedrijfID: number;
  Autobedrijf: string;
  Vestiging: string;
  VestigingID: number;
  Modeljaar: string;
  Goedgekeurd: string;
  RelatieTypeID: number;
  RelatieType: string;
  //importeurspecifieke velden:
  Merk?: string;
}

interface PivotOrdersViewModel {
  Orders: PivotOrderWithLabelsViewModel[];
}

interface PivotGridFieldsViewModel {
  Fields: string;
}

interface ILookupOrdersViewModel {
  Zones: LookupItemViewModel[];
  Autobedrijven: LookupItemViewModel[];
  Vestigingen: LookupItemViewModel[];
}

interface ILookupDictionary {
  [LookupID: string]: string;
}

export default Vue.extend({
  components: {
    TemplateSelection,
    OrdersPivotFilters,
    PivotGrid,
    PivotChart,
    TransitionExpand,
  },

  data() {
    return {
      oldGridFields: null as
        | null
        | {
            dataField: string;
            caption: string;
            visible?: boolean;
            selector?: any;
          }[],
      showFilterFields: true,
      pivotgridData: [] as PivotOrderWithLabelsViewModel[],
      getDataDebounced: null as null | Function,
      selectedOptions: {
        period: null as null | any,
        zonesValue: [] as any[],
        vestigingenValue: [] as any[],
        autobedrijvenValue: [] as any[],
        modellenValue: [] as any[],
        merkenValue: [] as any[],
        modeljarenValue: [] as any[],
        periodFromDate: new Date(),
        periodToDate: new Date(),
        customFromDate: new Date(),
        customToDate: new Date(),
        comparePeriodData: false as boolean,
        customFromDateCompare: new Date(),
        customToDateCompare: new Date(),
      } as FilterPivotOrderValues,

      dictionaryAutobedrijven: {} as ILookupDictionary,
      dictionaryVestigingen: {} as ILookupDictionary,
      dictionaryZones: {} as ILookupDictionary,
      extragridFields: [] as string[],
      defaultgridFields: [] as any[],
      pivotDefinitieType: PivotDefinitieType.Orders as Number,
    };
  },

  computed: {
    templateSelection(): any {
      return this.$refs["templateSelection"];
    },

    zoneGebruiker(): boolean {
      return this.$store.getters.zoneUser;
    },

    zoneFields(): string[] {
      return this.$store.getters.zoneFields;
    },

    filters(): any {
      return this.$refs["filters"];
    },

    pivotgrid(): any {
      return this.$refs["pivotgrid"];
    },

    pivotchart(): any {
      return this.$refs["pivotchart"];
    },

    triangle(): string {
      return this.showFilterFields ? "fas fa-caret-up" : "fas fa-caret-down";
    },

    multipleMakes(): boolean {
      return this.$store.getters.multipleMakes();
    },
  },

  created() {
    this.getSavedGridPreferences();
    this.getDataDebounced = debounce(() => {
      this.loadOrders();
    }, 500);
  },

  mounted() {
    this.initilizeDefaultGridFields();
    this.getLookupData();
  },

  methods: {
    loadOrders(): void {
      const queryData = this.getQueryData();
      axios
        .post("/api/backend/v1/dashboard/orders/grid/query", queryData)
        .then((response) => {
          if (!!response && !!response.data) {
            this.setGridData(response.data.Orders);
            this.fillGrid(this.oldGridFields, this.pivotgridData);
          }
        })
        .catch((error) => {});
    },

     filterForPermissions(fields: {dataField: string; caption: string; visible?: boolean; selector?: any;}[]): {dataField: string; caption: string; visible?: boolean; selector?: any;}[]{
      fields.forEach(f => {
        if(this.zoneFields.includes(f.dataField))
          f.visible = this.zoneGebruiker
      }, this)
      return fields
    },

    getLookupData(): void {
      axios
        .get("/api/backend/v1/dashboard/orders/grid/lookups")
        .then((response) => {
          if (!!response && !!response.data) {
            const autobedrijven = (response.data as ILookupOrdersViewModel)
              .Autobedrijven;
            this.dictionaryAutobedrijven = Object.assign(
              {},
              ...autobedrijven.map((x) => ({ [x.LookupID]: x.LookupValue }))
            );

            const vestigingen = (response.data as ILookupOrdersViewModel)
              .Vestigingen;
            this.dictionaryVestigingen = Object.assign(
              {},
              ...vestigingen.map((x) => ({ [x.LookupID]: x.LookupValue }))
            );

            const zones = (response.data as ILookupOrdersViewModel).Zones;
            this.dictionaryZones = Object.assign(
              {},
              ...zones.map((x) => ({ [x.LookupID]: x.LookupValue }))
            );
          }
        })
        .catch((error) => {});
    },

    setGridData(orders: PivotOrderWithLabelsViewModel[]): void {
      orders = orders || [];

      if (this.multipleMakes && !isEmpty(this.selectedOptions.merkenValue)) {
        this.pivotgridData = orders.filter(
          (order) =>
            !!order.Merk &&
            !!this.selectedOptions.merkenValue.find((m) => m.Id === order.Merk)
        );
      } else {
        this.pivotgridData = orders;
      }

      this.pivotgridData.forEach((record) => {
        if (this.dictionaryZones.hasOwnProperty(record.ZoneID.toString())) {
          record.Zone = this.dictionaryZones[record.ZoneID.toString()];
        }

        if (
          this.dictionaryAutobedrijven.hasOwnProperty(
            record.AutobedrijfID.toString()
          )
        ) {
          record.Autobedrijf = this.dictionaryAutobedrijven[
            record.AutobedrijfID.toString()
          ];
        }

        if (
          this.dictionaryVestigingen.hasOwnProperty(
            record.VestigingID.toString()
          )
        ) {
          record.Vestiging = this.dictionaryVestigingen[
            record.VestigingID.toString()
          ];
        }

        switch (record.RelatieTypeID) {
          case RelatieSoort.Particulier:
            record.RelatieType = this.$t("relatieparticulier").toString();
            break;
          case RelatieSoort.Zakelijk:
            record.RelatieType = this.$t("relatiezakelijk").toString();
            break;
          case RelatieSoort.Lease:
            record.RelatieType = this.$t("relatielease").toString();
            break;
          default:
            record.RelatieType = this.$t("unknown").toString();
            break;
        }
      });
  
    },

    getSavedGridPreferences(): void {
      axios
        .get("/api/backend/v1/identity/preferences/orders/pivot/grid")
        .then((response) => {
          if (!!response && !!response.data) {
            if (
              !isEmpty(response.data.ExtraVelden) &&
              Array.isArray(response.data.ExtraVelden)
            ) {
              this.extragridFields = response.data.ExtraVelden;
            }

            if (!!response.data.FilterSettings) {
              this.oldGridFields = this.filterForPermissions(JSON.parse(
                response.data.FilterSettings.Fields
              ));
            } else {
              this.oldGridFields = this.defaultgridFields;
            }

            if (!isEmpty(this.extragridFields)) {
              this.extragridFields.forEach((extraveld) => {
                if (
                  !!this.oldGridFields &&
                  !this.oldGridFields.find((a) => a.dataField === extraveld)
                ) {
                  this.oldGridFields.push({
                    dataField: extraveld,
                    caption: this.$t("grid" + extraveld).toString(),
                  });
                }
              });
            }

            this.setGridSelectorsAndHeaders(this.oldGridFields);
          }
        })
        .catch((error) => {
          EventBus.$emit("add-toastr", {
            text: this.$t("pivotgridfieldserror").toString(),
            type: "error",
          });
        });
    },

    saveGridPreferences(newGridFields: string): void {
      let model = { Fields: newGridFields } as PivotGridFieldsViewModel;
      axios
        .post("/api/backend/v1/identity/preferences/orders/pivot/grid", model, {
          headers: { "Content-Type": "application/json" },
        })
        .catch((error) => {
          EventBus.$emit("add-toastr", {
            text: this.$t("gridsaveerror").toString(),
            type: "error",
          });
        });
    },

    getFilterFields(): string {
      let filters = this.filters.getPreferences();
      return JSON.stringify(filters);
    },

    fillGrid(
      fields:
        | null
        | {
            caption: string;
            dataField: string;
            selector?: any;
          }[],
      store: PivotOrderWithLabelsViewModel[]
    ): void {
      this.pivotgrid.fillGrid(fields, store);
      this.bindChart();
    },

    getGridFields(): string {
      let fields = this.pivotgrid.getFields();
      return JSON.stringify(fields);
    },

    setGridFields(jsonstring: string): void {
      if (jsonstring === "{}") return;

      let newFields = this.filterForPermissions(JSON.parse(jsonstring));
      this.pivotgrid.setFields(newFields);
      this.bindChart();
    },

    bindChart(): void {
      const chart = this.pivotchart.getInstance();
      this.pivotgrid.bindChart(chart, false);
    },

    initilizeDefaultGridFields() {
      this.defaultgridFields = [
        {
          caption: this.$i18n.t("gridorderdate"),
          dataField: "Order",
          area: "filter",
        },
        {
          caption: this.$i18n.t("gridapproveddate"),
          dataField: "Goedgekeurd",
        },
        {
          caption: this.$i18n.t("gridapprovedyearweek"),
        },
        {
          caption: this.$i18n.t("gridapprovedyearmonth"),
        },
        {
          caption: this.$i18n.t("gridapprovedyear"),
        },
        {
          caption: this.$i18n.t("gridapprovedmonth"),
        },
        {
          caption: this.$i18n.t("gridapprovedday"),
        },
        {
          caption: this.$i18n.t("gridorderyearweek"),
        },
        {
          caption: this.$i18n.t("gridorderyearmonth"),
        },
        {
          caption: this.$i18n.t("gridorderyear"),
        },
        {
          caption: this.$i18n.t("gridordermonth"),
        },
        // {
        //   caption: this.$i18n.t("gridorderweek")
        // },
        {
          caption: this.$i18n.t("gridorderday"),
        },
        {
          caption: this.$i18n.t("gridmodelmodelyear"),
        },
        {
          caption: this.$i18n.t("gridregion"),
          dataField: "Zone",
          area: "row",
          visible: this.zoneGebruiker,
        },
        {
          caption: this.$i18n.t("gridregionid"),
          dataField: "ZoneID",
          visible: false,
        },
        {
          caption: this.$i18n.t("gridapprovedweeknumber"),
          dataField: "WeeknumberGoedgekeurd",
          visible: false,
        },
        {
          caption: this.$i18n.t("gridorderweeknumber"),
          dataField: "WeeknumberOrder",
          visible: false,
        },
        {
          caption: this.$i18n.t("griddealerid"),
          dataField: "AutobedrijfID",
          visible: false,
        },
        {
          caption: this.$i18n.t("griddealer"),
          dataField: "Autobedrijf",
          area: "row",
          visible: this.zoneGebruiker,
        },
        {
          caption: this.$i18n.t("gridlocationid"),
          dataField: "VestigingID",
          visible: false,
        },
        {
          caption: this.$i18n.t("gridlocation"),
          dataField: "Vestiging",
          area: "row",
        },
        {
          caption: this.$i18n.t("gridmodel"),
          dataField: "Model",
          area: "column",
        },
        {
          caption: this.$i18n.t("gridmodelyear"),
          dataField: "Modeljaar",
          visible: false,
        },
        {
          caption: this.$i18n.t("gridcount"),
          summaryType: "count",
          area: "data",
        },
        {
          caption: this.$i18n.t("gridrelatietypeid"),
          dataField: "RelatieTypeID",
          visible: false,
        },
        {
          caption: this.$i18n.t("gridrelatietype"),
          dataField: "RelatieType",
        },
      ] as any[];
    },

    setGridSelectorsAndHeaders(
      dataList: null | { dataField: string; caption: string; selector?: any }[]
    ) {
      if (dataList === null || isEmpty(dataList)) return;

      dataList.forEach((field) => {
        switch (field.caption) {
          case this.$i18n.t("gridapprovedyearweek", "nl"):
          case this.$i18n.t("gridapprovedyearweek", "en"):
            field.caption = this.$i18n.t("gridapprovedyearweek").toString();
            field.selector = function(data: any) {
              if (data.Goedgekeurd != null) {
                let year = data.Goedgekeurd.substring(0, 4);
                return `${year}-${data.WeeknumberGoedgekeurd}`;
              }
              return "";
            };
            break;
          case this.$i18n.t("gridapprovedyearmonth", "nl"):
          case this.$i18n.t("gridapprovedyearmonth", "en"):
            field.caption = this.$i18n.t("gridapprovedyearmonth").toString();
            field.selector = function(data: any) {
              if (data.Goedgekeurd != null) {
                let yearmnd = data.Goedgekeurd.substring(0, 7);
                return `${yearmnd}`;
              }
              return "";
            };
            break;
          case this.$i18n.t("gridapprovedyear", "nl"):
          case this.$i18n.t("gridapprovedyear", "en"):
            field.caption = this.$i18n.t("gridapprovedyear").toString();
            field.selector = function(data: any) {
              if (data.Goedgekeurd != null) {
                let yearmnd = data.Goedgekeurd.substring(0, 4);
                return `${yearmnd}`;
              }
              return "";
            };
            break;
          case this.$i18n.t("gridapprovedmonth", "nl"):
          case this.$i18n.t("gridapprovedmonth", "en"):
            field.caption = this.$i18n.t("gridapprovedmonth").toString();
            let localThis = this;
            field.selector = function(data: any) {
              if (data.Goedgekeurd != null) {
                let month = data.Goedgekeurd.substring(5, 7);
                return month;
              }
              return "";
            };
            break;
          case this.$i18n.t("gridapprovedday", "nl"):
          case this.$i18n.t("gridapprovedday", "en"):
            field.caption = this.$i18n.t("gridapprovedday").toString();
            field.selector = function(data: any) {
              if (data.Goedgekeurd != null) {
                let day = data.Goedgekeurd.substring(8, 10);
                return `${day}`;
              }
              return "";
            };
            break;
          case this.$i18n.t("gridorderyearweek", "nl"):
          case this.$i18n.t("gridorderyearweek", "en"):
            field.caption = this.$i18n.t("gridorderyearweek").toString();
            field.selector = function(data: any) {
              if (data.Order != null) {
                let year = data.Order.substring(0, 4);
                return `${year}-${data.WeeknumberOrder}`;
              }
              return "";
            };
            break;
          case this.$i18n.t("gridorderyearmonth", "nl"):
          case this.$i18n.t("gridorderyearmonth", "en"):
            field.caption = this.$i18n.t("gridorderyearmonth").toString();
            field.selector = function(data: any) {
              if (data.Order != null) {
                let yearmnd = data.Order.substring(0, 7);
                return `${yearmnd}`;
              }
              return "";
            };
            break;
          case this.$i18n.t("gridorderyear", "nl"):
          case this.$i18n.t("gridorderyear", "en"):
            field.caption = this.$i18n.t("gridorderyear").toString();
            field.selector = function(data: any) {
              if (data.Order != null) {
                let year = data.Order.substring(0, 4);
                return `${year}`;
              }
              return "";
            };
            break;
          case this.$i18n.t("gridordermonth", "nl"):
          case this.$i18n.t("gridordermonth", "en"):
            field.caption = this.$i18n.t("gridordermonth").toString();
            field.selector = function(data: any) {
              if (data.Order != null) {
                let month = data.Order.substring(5, 7);
                return `${month}`;
              }
              return "";
            };
            break;
          // case this.$i18n.t("gridorderweek", "nl"):
          // case this.$i18n.t("gridorderweek", "en"):
          //   field.caption = this.$i18n.t("gridorderweek").toString();
          //   field.selector = function(data: any) {
          //     return `${data.AaWk}`;
          //   };
          //   break;
          case this.$i18n.t("gridorderday", "nl"):
          case this.$i18n.t("gridorderday", "en"):
            field.caption = this.$i18n.t("gridorderday").toString();
            field.selector = function(data: any) {
              if (data.Order != null) {
                let day = data.Order.substring(8, 10);
                return `${day}`;
              }
              return "";
            };
            break;
          case this.$i18n.t("gridmodelmodelyear", "nl"):
          case this.$i18n.t("gridmodelmodelyear", "en"):
            field.caption = this.$i18n.t("gridmodelmodelyear").toString();
            field.selector = function(data: any) {
              return `${data.Model} ${data.Modeljaar}`;
            };
            break;
          case this.$i18n.t("gridorderdate", "nl"):
          case this.$i18n.t("gridorderdate", "en"):
            field.caption = this.$i18n.t("gridorderdate").toString();
            break;
          case this.$i18n.t("gridorderweeknumber", "nl"):
          case this.$i18n.t("gridorderweeknumber", "en"):
            field.caption = this.$i18n.t("gridorderweeknumber").toString();
            break;
          case this.$i18n.t("gridapproveddate", "nl"):
          case this.$i18n.t("gridapproveddate", "en"):
            field.caption = this.$i18n.t("gridapproveddate").toString();
            break;
          case this.$i18n.t("gridapprovedweeknumber", "nl"):
          case this.$i18n.t("gridapprovedweeknumber", "en"):
            field.caption = this.$i18n.t("gridapprovedweeknumber").toString();
            break;
          case this.$i18n.t("gridmodel", "nl"):
          case this.$i18n.t("gridmodel", "en"):
            field.caption = this.$i18n.t("gridmodel").toString();
            break;
          case this.$i18n.t("gridmodelyear", "nl"):
          case this.$i18n.t("gridmodelyear", "en"):
            field.caption = this.$i18n.t("gridmodelyear").toString();
            break;
          case this.$i18n.t("gridregion", "nl"):
          case this.$i18n.t("gridregion", "en"):
            field.caption = this.$i18n.t("gridregion").toString();
            break;
          case this.$i18n.t("gridregionid", "nl"):
          case this.$i18n.t("gridregionid", "en"):
            field.caption = this.$i18n.t("gridregionid").toString();
            break;
          case this.$i18n.t("griddealer", "nl"):
          case this.$i18n.t("griddealer", "en"):
            field.caption = this.$i18n.t("griddealer").toString();
            break;
          case this.$i18n.t("griddealerid", "nl"):
          case this.$i18n.t("griddealerid", "en"):
            field.caption = this.$i18n.t("griddealerid").toString();
            break;
          case this.$i18n.t("gridlocation", "nl"):
          case this.$i18n.t("gridlocation", "en"):
            field.caption = this.$i18n.t("gridlocation").toString();
            break;
          case this.$i18n.t("gridcount", "nl"):
          case this.$i18n.t("gridcount", "en"):
            field.caption = this.$i18n.t("gridcount").toString();
            break;
          case this.$i18n.t("gridrelatietype", "nl"):
          case this.$i18n.t("gridrelatietype", "en"):
            field.caption = this.$i18n.t("gridrelatietype").toString();
            break;
        }
        // vertaal extra velden
        if (!isEmpty(this.extragridFields)) {
          this.extragridFields.forEach((extraVeld) => {
            if (field.dataField === extraVeld) {
              field.caption = this.$i18n.t("grid" + extraVeld).toString();
            }
          });
        }
      });
    },

    onGridFieldsChanged(): void {
      if (this.pivotgrid.fieldsLoaded()) {
        let currentGridFields = this.getGridFields();
        if (currentGridFields !== JSON.stringify(this.oldGridFields)) {
          this.saveGridPreferences(currentGridFields);
        }
        this.oldGridFields = JSON.parse(currentGridFields);
        this.setGridSelectorsAndHeaders(this.oldGridFields);
      }
    },

    onFiltersInitialised(): void {
      this.onFilterPreferencesChanged();
    },

    onFilterPreferencesChanged(): void {
      this.handleDataChanged();
    },

    handleDataChanged(): void {
      if (!!this.getDataDebounced) {
        this.getDataDebounced();
      }
    },

    toggleShowHideFilterFields(): void {
      this.showFilterFields = !this.showFilterFields;
    },

    onTemplateSaveClick(): void {
      this.templateSelection.processSave(
        this.getFilterFields(),
        this.getGridFields()
      );
    },

    loadTemplateSettings(filterSettings: string, pivotSettings: string): void {
      this.setGridFields(pivotSettings);
      this.filters.setPreferences(filterSettings);
    },

    getQueryData(): PivotOrderQueryViewModel {
      const isCustomInput =
        get(this.selectedOptions, "period.Id", FixedPeriodType.ThisYear) ===
        FixedPeriodType.FreePeriod;

      const isComparePeriodData = this.selectedOptions.comparePeriodData;
      const fromDate = isCustomInput
        ? (moment(this.selectedOptions.customFromDate)).local().startOf("day").toDate().toISOString()
        : this.selectedOptions.periodFromDate.toISOString();
      const toDate = isCustomInput
        ? (moment(this.selectedOptions.customToDate)).local().endOf("day").toDate().toISOString()
        : this.selectedOptions.periodToDate.toISOString();

      const fromDateCompare = isComparePeriodData
        ? (moment(this.selectedOptions.customFromDateCompare)).local().startOf("day").toDate().toISOString()
        : null;
      const toDateCompare = isComparePeriodData
        ? (moment(this.selectedOptions.customToDateCompare)).local().endOf("day").toDate().toISOString()
        : null;	

      const model = {
        FromDate: fromDate,
        ToDate: toDate,
        FromDateCompare: fromDateCompare,
        ToDateCompare: toDateCompare,

        Zones: get(this.selectedOptions as Object, "zonesValue", []).map(
          (elem: any) => Number(elem["Id"])
        ),
        Autobedrijven: get(
          this.selectedOptions as Object,
          "autobedrijvenValue",
          []
        ).map((elem: any) => String(elem["Id"])),
        Modeljaren: get(
          this.selectedOptions as Object,
          "modeljarenValue",
          []
        ).map((elem: any) => Number(elem["Id"])),
        Modellen: get(this.selectedOptions as Object, "modellenValue", []).map(
          (elem: any) => String(elem["Id"])
        ),
        Vestigingen: get(
          this.selectedOptions as Object,
          "vestigingenValue",
          []
        ).map((elem: any) => String(elem["Id"])),
      } as PivotOrderQueryViewModel;

      return model;
    },
  },
});
